import { useTheme } from 'styled-components';

export const SmallInformationIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.9863 0C7.7504 0 10 2.2492 10 4.9863C10 7.7504 7.7508 10 4.9863 10C2.2492 10 0 7.7508 0 4.9863C0 2.2492 2.2492 0 4.9863 0ZM5.2031 1.9242C5.66365 1.9242 6.01599 2.3035 6.01599 2.73709C5.98904 3.19764 5.63669 3.54998 5.2031 3.54998C4.74255 3.54998 4.39021 3.17068 4.39021 2.73709C4.39021 2.27654 4.76951 1.9242 5.2031 1.9242ZM6.3683 7.3984C6.12455 8.29254 3.7394 8.37418 3.9023 7.15465C4.01089 6.34176 4.17339 5.55585 4.30894 4.76985C4.39019 4.25501 4.06519 4.41751 3.76675 4.3093C3.57691 4.22805 3.57691 3.98391 3.82105 3.93C4.1191 3.84875 5.17615 3.90305 5.52845 3.90305C5.71829 3.90305 5.8265 4.01164 5.85384 4.2011C5.85384 4.3636 5.82688 4.49915 5.79954 4.66165C5.66399 5.42063 5.47415 6.23355 5.36595 6.99215C5.36595 7.15465 5.3929 7.4527 5.63704 7.42574C5.88079 7.42574 5.98938 7.31715 6.17923 7.2359C6.28782 7.1816 6.39603 7.26285 6.36907 7.3984L6.3683 7.3984Z"
        fill={theme.sweetGrey}
      />
    </svg>
  );
};
